import React from "react";
import {
  AtlDuotone,
  AtLsAcrossSubjectsDuotone,
  AcademicSetupDuotone,
  ActionsDuotone,
  ArtDuotone,
  AssessmentsDuotone,
  AttendanceClipboardDuotone,
  BinDuotone,
  BiologyDuotone,
  BriefcaseDuotone,
  CasDuotone,
  CheckShieldCardsDuotone,
  ChemistryDuotone,
  CivicsDuotone,
  ClipboardBarGraphDuotone,
  ClipboardLinesDuotone,
  ClipboardPencilLinesDuotone,
  CognitiveDevelopmentDuotone,
  ContentDuotone,
  DanceDuotone,
  DesignDuotone,
  DifferentiationDuotone,
  EnglishDuotone,
  ExtendedEssayDuotone,
  FeedbackDuotone,
  FormativeAssessmentDuotone,
  FormsOfIntegrationDuotone,
  Frame20Duotone,
  FrenchDuotone,
  GeographyDuotone,
  GlobalContextDuotone,
  GridDuotone,
  HandDuotone,
  HeartDuotone,
  HelpCenterDuotone,
  HindiDuotone,
  HistoryDuotone,
  HorizontalViewAcrossSubjectAreasDuotone,
  HorizontalViewKcDuotone,
  IndisciplinaryCriteriaDuotone,
  IndividualsSocietiesDuotone,
  InquiryQuestionsDuotone,
  InterdisciplinaryLEandTeachingStrategiesDuotone,
  JournalDuotone,
  KeyConceptDuotone,
  KeyRelatedConceptsDuotone,
  KoreanDuotone,
  LeAndTeachingStrategiesDuotone,
  LanguageAcquisitionDuotone,
  LanguageLiteratureDuotone,
  LearnerProfileDuotone,
  LearningExperienceDuotone,
  LearningStandardsDuotone,
  LinesOfInquiryDuotone,
  MandarinDuotone,
  MathematicsDuotone,
  MathsDuotone,
  MusicDuotone,
  ObjectivesDuotone,
  OpenBookDuotone,
  PhysicalHealthEducationDuotone,
  PhysicsDuotone,
  PreliminaryReviewDuotone,
  PresentationDuotone,
  PriorLearningDuotone,
  ProgrammeofInquiryDuotone,
  ProgressReportDuotone,
  PurposeOfIntegrationDuotone,
  ReflectionAfterTeachingDuotone,
  ReflectionDuringTeachingDuotone,
  ReflectionPriorToTeachingDuotone,
  RelatedConceptsDuotone,
  ResourceDuotone,
  SchoolVisitDuotone,
  SciencesDuotone,
  SelfAssessmentDuotone,
  SelfReflectionDuotone,
  SelfStudyDuotone,
  SettingsDuotone,
  ShieldTickDuotone,
  SpanishDuotone,
  SpiralBookLinesDuotone,
  SportsDuotone,
  StatementOfInquiryDuotone,
  StudentAgencyDuotone,
  SubjectFocusDuotone,
  SubjectGenericDuotone,
  SubjectOverviewDuotone,
  SummativeAssessmentDuotone,
  ThemeDescriptorInsightsDuotone,
  TheoryofKnowledgeDuotone,
  TimelineDuotone,
  ToddleAcademyDuotone,
  TransdisciplinaryThemeDuotone,
  WhatsNewDuotone,
} from "@toddle-edu/ds-icons";

export const getIconList = ({
  size = "small",
  containerStyle = {},
  hasBackground = true,
} = {}) => {
  const iconList = {
    AtlDuotone: {
      iconName: "AtlDuotone",
      displayName: "ATL",
      component: (
        <AtlDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    AtLsAcrossSubjectsDuotone: {
      iconName: "AtLsAcrossSubjectsDuotone",
      displayName: "ATLs across subjects",
      component: (
        <AtLsAcrossSubjectsDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    AcademicSetupDuotone: {
      iconName: "AcademicSetupDuotone",
      displayName: "Academic setup",
      component: (
        <AcademicSetupDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    ActionsDuotone: {
      iconName: "ActionsDuotone",
      displayName: "Actions",
      component: (
        <ActionsDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    ArtDuotone: {
      iconName: "ArtDuotone",
      displayName: "Art",
      component: (
        <ArtDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    AssessmentsDuotone: {
      iconName: "AssessmentsDuotone",
      displayName: "Assessments",
      component: (
        <AssessmentsDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    AttendanceClipboardDuotone: {
      iconName: "AttendanceClipboardDuotone",
      displayName: "Attendance clipboard",
      component: (
        <AttendanceClipboardDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    BinDuotone: {
      iconName: "BinDuotone",
      displayName: "Bin",
      component: (
        <BinDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    BiologyDuotone: {
      iconName: "BiologyDuotone",
      displayName: "Biology",
      component: (
        <BiologyDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    BriefcaseDuotone: {
      iconName: "BriefcaseDuotone",
      displayName: "Briefcase",
      component: (
        <BriefcaseDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    CasDuotone: {
      iconName: "CasDuotone",
      displayName: "CAS",
      component: (
        <CasDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    CheckShieldCardsDuotone: {
      iconName: "CheckShieldCardsDuotone",
      displayName: "Check shield cards",
      component: (
        <CheckShieldCardsDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    ChemistryDuotone: {
      iconName: "ChemistryDuotone",
      displayName: "Chemistry",
      component: (
        <ChemistryDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    CivicsDuotone: {
      iconName: "CivicsDuotone",
      displayName: "Civics",
      component: (
        <CivicsDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    ClipboardBarGraphDuotone: {
      iconName: "ClipboardBarGraphDuotone",
      displayName: "Clipboard bar graph",
      component: (
        <ClipboardBarGraphDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    ClipboardLinesDuotone: {
      iconName: "ClipboardLinesDuotone",
      displayName: "Clipboard lines",
      component: (
        <ClipboardLinesDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    ClipboardPencilLinesDuotone: {
      iconName: "ClipboardPencilLinesDuotone",
      displayName: "Clipboard pencil lines",
      component: (
        <ClipboardPencilLinesDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    CognitiveDevelopmentDuotone: {
      iconName: "CognitiveDevelopmentDuotone",
      displayName: "Cognitive development",
      component: (
        <CognitiveDevelopmentDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    ContentDuotone: {
      iconName: "ContentDuotone",
      displayName: "Content",
      component: (
        <ContentDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    DanceDuotone: {
      iconName: "DanceDuotone",
      displayName: "Dance",
      component: (
        <DanceDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    DesignDuotone: {
      iconName: "DesignDuotone",
      displayName: "Design",
      component: (
        <DesignDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    DifferentiationDuotone: {
      iconName: "DifferentiationDuotone",
      displayName: "Differentiation",
      component: (
        <DifferentiationDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    EnglishDuotone: {
      iconName: "EnglishDuotone",
      displayName: "English",
      component: (
        <EnglishDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    ExtendedEssayDuotone: {
      iconName: "ExtendedEssayDuotone",
      displayName: "Extended essay",
      component: (
        <ExtendedEssayDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    FeedbackDuotone: {
      iconName: "FeedbackDuotone",
      displayName: "Feedback",
      component: (
        <FeedbackDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    FormativeAssessmentDuotone: {
      iconName: "FormativeAssessmentDuotone",
      displayName: "Formative assessment",
      component: (
        <FormativeAssessmentDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    FormsOfIntegrationDuotone: {
      iconName: "FormsOfIntegrationDuotone",
      displayName: "Forms of integration",
      component: (
        <FormsOfIntegrationDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    Frame20Duotone: {
      iconName: "Frame20Duotone",
      displayName: "Frame 20",
      component: (
        <Frame20Duotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    FrenchDuotone: {
      iconName: "FrenchDuotone",
      displayName: "French",
      component: (
        <FrenchDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    GeographyDuotone: {
      iconName: "GeographyDuotone",
      displayName: "Geography",
      component: (
        <GeographyDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    GlobalContextDuotone: {
      iconName: "GlobalContextDuotone",
      displayName: "Global context",
      component: (
        <GlobalContextDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    GridDuotone: {
      iconName: "GridDuotone",
      displayName: "Grid",
      component: (
        <GridDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    HandDuotone: {
      iconName: "HandDuotone",
      displayName: "Hand",
      component: (
        <HandDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    HeartDuotone: {
      iconName: "HeartDuotone",
      displayName: "Heart",
      component: (
        <HeartDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    HelpCenterDuotone: {
      iconName: "HelpCenterDuotone",
      displayName: "Help center",
      component: (
        <HelpCenterDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    HindiDuotone: {
      iconName: "HindiDuotone",
      displayName: "Hindi",
      component: (
        <HindiDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    HistoryDuotone: {
      iconName: "HistoryDuotone",
      displayName: "History",
      component: (
        <HistoryDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    HorizontalViewAcrossSubjectAreasDuotone: {
      iconName: "HorizontalViewAcrossSubjectAreasDuotone",
      displayName: "Horizontal view across subject areas",
      component: (
        <HorizontalViewAcrossSubjectAreasDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    HorizontalViewKcDuotone: {
      iconName: "HorizontalViewKcDuotone",
      displayName: "Horizontal view KC",
      component: (
        <HorizontalViewKcDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    IndisciplinaryCriteriaDuotone: {
      iconName: "IndisciplinaryCriteriaDuotone",
      displayName: "Indisciplinary criteria",
      component: (
        <IndisciplinaryCriteriaDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    IndividualsSocietiesDuotone: {
      iconName: "IndividualsSocietiesDuotone",
      displayName: "Individuals societies",
      component: (
        <IndividualsSocietiesDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    InquiryQuestionsDuotone: {
      iconName: "InquiryQuestionsDuotone",
      displayName: "Inquiry questions",
      component: (
        <InquiryQuestionsDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    InterdisciplinaryLEandTeachingStrategiesDuotone: {
      iconName: "InterdisciplinaryLEandTeachingStrategiesDuotone",
      displayName: "Interdisciplinary LE and teaching strategies",
      component: (
        <InterdisciplinaryLEandTeachingStrategiesDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    JournalDuotone: {
      iconName: "JournalDuotone",
      displayName: "Journal",
      component: (
        <JournalDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    KeyConceptDuotone: {
      iconName: "KeyConceptDuotone",
      displayName: "Key concept",
      component: (
        <KeyConceptDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    KeyRelatedConceptsDuotone: {
      iconName: "KeyRelatedConceptsDuotone",
      displayName: "Key related concepts",
      component: (
        <KeyRelatedConceptsDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    KoreanDuotone: {
      iconName: "KoreanDuotone",
      displayName: "Korean",
      component: (
        <KoreanDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    LeAndTeachingStrategiesDuotone: {
      iconName: "LeAndTeachingStrategiesDuotone",
      displayName: "LE and teaching strategies",
      component: (
        <LeAndTeachingStrategiesDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    LanguageAcquisitionDuotone: {
      iconName: "LanguageAcquisitionDuotone",
      displayName: "Language acquisition",
      component: (
        <LanguageAcquisitionDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    LanguageLiteratureDuotone: {
      iconName: "LanguageLiteratureDuotone",
      displayName: "Language literature",
      component: (
        <LanguageLiteratureDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    LearnerProfileDuotone: {
      iconName: "LearnerProfileDuotone",
      displayName: "Learner profile",
      component: (
        <LearnerProfileDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    LearningExperienceDuotone: {
      iconName: "LearningExperienceDuotone",
      displayName: "Learning experience",
      component: (
        <LearningExperienceDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    LearningStandardsDuotone: {
      iconName: "LearningStandardsDuotone",
      displayName: "Learning standards",
      component: (
        <LearningStandardsDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    LinesOfInquiryDuotone: {
      iconName: "LinesOfInquiryDuotone",
      displayName: "Lines of inquiry",
      component: (
        <LinesOfInquiryDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    MandarinDuotone: {
      iconName: "MandarinDuotone",
      displayName: "Mandarin",
      component: (
        <MandarinDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    MathematicsDuotone: {
      iconName: "MathematicsDuotone",
      displayName: "Mathematics",
      component: (
        <MathematicsDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    MathsDuotone: {
      iconName: "MathsDuotone",
      displayName: "Maths",
      component: (
        <MathsDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    MusicDuotone: {
      iconName: "MusicDuotone",
      displayName: "Music",
      component: (
        <MusicDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    ObjectivesDuotone: {
      iconName: "ObjectivesDuotone",
      displayName: "Objectives",
      component: (
        <ObjectivesDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    OpenBookDuotone: {
      iconName: "OpenBookDuotone",
      displayName: "Open book",
      component: (
        <OpenBookDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    PhysicalHealthEducationDuotone: {
      iconName: "PhysicalHealthEducationDuotone",
      displayName: "Physical health education",
      component: (
        <PhysicalHealthEducationDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    PhysicsDuotone: {
      iconName: "PhysicsDuotone",
      displayName: "Physics",
      component: (
        <PhysicsDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    PreliminaryReviewDuotone: {
      iconName: "PreliminaryReviewDuotone",
      displayName: "Preliminary review",
      component: (
        <PreliminaryReviewDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    PresentationDuotone: {
      iconName: "PresentationDuotone",
      displayName: "Presentation",
      component: (
        <PresentationDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    PriorLearningDuotone: {
      iconName: "PriorLearningDuotone",
      displayName: "Prior learning",
      component: (
        <PriorLearningDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    ProgrammeofInquiryDuotone: {
      iconName: "ProgrammeofInquiryDuotone",
      displayName: "Programme of inquiry",
      component: (
        <ProgrammeofInquiryDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    ProgressReportDuotone: {
      iconName: "ProgressReportDuotone",
      displayName: "Progress report",
      component: (
        <ProgressReportDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    PurposeOfIntegrationDuotone: {
      iconName: "PurposeOfIntegrationDuotone",
      displayName: "Purpose of integration",
      component: (
        <PurposeOfIntegrationDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    ReflectionAfterTeachingDuotone: {
      iconName: "ReflectionAfterTeachingDuotone",
      displayName: "Reflection after teaching",
      component: (
        <ReflectionAfterTeachingDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    ReflectionDuringTeachingDuotone: {
      iconName: "ReflectionDuringTeachingDuotone",
      displayName: "Reflection during teaching",
      component: (
        <ReflectionDuringTeachingDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    ReflectionPriorToTeachingDuotone: {
      iconName: "ReflectionPriorToTeachingDuotone",
      displayName: "Reflection prior to teaching",
      component: (
        <ReflectionPriorToTeachingDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    RelatedConceptsDuotone: {
      iconName: "RelatedConceptsDuotone",
      displayName: "Related concepts",
      component: (
        <RelatedConceptsDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    ResourceDuotone: {
      iconName: "ResourceDuotone",
      displayName: "Resource",
      component: (
        <ResourceDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    SchoolVisitDuotone: {
      iconName: "SchoolVisitDuotone",
      displayName: "School visit",
      component: (
        <SchoolVisitDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    SciencesDuotone: {
      iconName: "SciencesDuotone",
      displayName: "Sciences",
      component: (
        <SciencesDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    SelfAssessmentDuotone: {
      iconName: "SelfAssessmentDuotone",
      displayName: "Self assessment",
      component: (
        <SelfAssessmentDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    SelfReflectionDuotone: {
      iconName: "SelfReflectionDuotone",
      displayName: "Self reflection",
      component: (
        <SelfReflectionDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    SelfStudyDuotone: {
      iconName: "SelfStudyDuotone",
      displayName: "Self study",
      component: (
        <SelfStudyDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    SettingsDuotone: {
      iconName: "SettingsDuotone",
      displayName: "Settings",
      component: (
        <SettingsDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    ShieldTickDuotone: {
      iconName: "ShieldTickDuotone",
      displayName: "Shield tick",
      component: (
        <ShieldTickDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    SpanishDuotone: {
      iconName: "SpanishDuotone",
      displayName: "Spanish",
      component: (
        <SpanishDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    SpiralBookLinesDuotone: {
      iconName: "SpiralBookLinesDuotone",
      displayName: "Spiral book lines",
      component: (
        <SpiralBookLinesDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    SportsDuotone: {
      iconName: "SportsDuotone",
      displayName: "Sports",
      component: (
        <SportsDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    StatementOfInquiryDuotone: {
      iconName: "StatementOfInquiryDuotone",
      displayName: "Statement of inquiry",
      component: (
        <StatementOfInquiryDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    StudentAgencyDuotone: {
      iconName: "StudentAgencyDuotone",
      displayName: "Student agency",
      component: (
        <StudentAgencyDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    SubjectFocusDuotone: {
      iconName: "SubjectFocusDuotone",
      displayName: "Subject focus",
      component: (
        <SubjectFocusDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    SubjectGenericDuotone: {
      iconName: "SubjectGenericDuotone",
      displayName: "Subject generic",
      component: (
        <SubjectGenericDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    SubjectOverviewDuotone: {
      iconName: "SubjectOverviewDuotone",
      displayName: "Subject overview",
      component: (
        <SubjectOverviewDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    SummativeAssessmentDuotone: {
      iconName: "SummativeAssessmentDuotone",
      displayName: "Summative assessment",
      component: (
        <SummativeAssessmentDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    ThemeDescriptorInsightsDuotone: {
      iconName: "ThemeDescriptorInsightsDuotone",
      displayName: "Theme descriptor insights",
      component: (
        <ThemeDescriptorInsightsDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    TheoryofKnowledgeDuotone: {
      iconName: "TheoryofKnowledgeDuotone",
      displayName: "Theory of knowledge",
      component: (
        <TheoryofKnowledgeDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    TimelineDuotone: {
      iconName: "TimelineDuotone",
      displayName: "Timeline",
      component: (
        <TimelineDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    ToddleAcademyDuotone: {
      iconName: "ToddleAcademyDuotone",
      displayName: "Toddle academy",
      component: (
        <ToddleAcademyDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    TransdisciplinaryThemeDuotone: {
      iconName: "TransdisciplinaryThemeDuotone",
      displayName: "Transdisciplinary theme",
      component: (
        <TransdisciplinaryThemeDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    WhatsNewDuotone: {
      iconName: "WhatsNewDuotone",
      displayName: "What's new",
      component: (
        <WhatsNewDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnKeyConcepts: {
      iconName: "PicnKeyConcepts",
      displayName: "PicnKeyConcepts",
      component: (
        <KeyConceptDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnPriorLearning: {
      iconName: "PicnPriorLearning",
      displayName: "PicnPriorLearning",
      component: (
        <PriorLearningDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnInquiryQues: {
      iconName: "PicnInquiryQues",
      displayName: "PicnInquiryQues",
      component: (
        <InquiryQuestionsDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnCentralIdea: {
      iconName: "PicnCentralIdea",
      displayName: "PicnCentralIdea",
      component: (
        <PurposeOfIntegrationDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnStudentAgency: {
      iconName: "PicnStudentAgency",
      displayName: "PicnStudentAgency",
      component: (
        <StudentAgencyDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnLearningGoals: {
      iconName: "PicnLearningGoals",
      displayName: "PicnLearningGoals",
      component: (
        <ObjectivesDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnTheme: {
      iconName: "PicnTheme",
      displayName: "PicnTheme",
      component: (
        <TransdisciplinaryThemeDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnConnections: {
      iconName: "PicnConnections",
      displayName: "PicnConnections",
      component: (
        <InterdisciplinaryLEandTeachingStrategiesDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnSubjectFocus: {
      iconName: "PicnSubjectFocus",
      displayName: "PicnSubjectFocus",
      component: (
        <SubjectFocusDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    HandDuotonePink: {
      iconName: "HandDuotonePink",
      displayName: "HandDuotonePink",
      component: (
        <HandDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnActions: {
      iconName: "PicnActions",
      displayName: "PicnActions",
      component: (
        <ActionsDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnATL: {
      iconName: "PicnATL",
      displayName: "PicnATL",
      component: (
        <AtlDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnRelatedConcepts: {
      iconName: "PicnRelatedConcepts",
      displayName: "PicnRelatedConcepts",
      component: (
        <RelatedConceptsDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    JournalDuotoneBlue: {
      iconName: "JournalDuotoneBlue",
      displayName: "JournalDuotoneBlue",
      component: (
        <JournalDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    PreliminaryReviewDuotoneBlue: {
      iconName: "PreliminaryReviewDuotoneBlue",
      displayName: "PreliminaryReviewDuotoneBlue",
      component: (
        <PreliminaryReviewDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnDisciplinarySubGeneric: {
      iconName: "PicnDisciplinarySubGeneric",
      displayName: "PicnDisciplinarySubGeneric",
      component: (
        <SubjectGenericDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnInterLearnExpTeachStrat: {
      iconName: "PicnInterLearnExpTeachStrat",
      displayName: "PicnInterLearnExpTeachStrat",
      component: (
        <InterdisciplinaryLEandTeachingStrategiesDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnInReflections: {
      iconName: "PicnInReflections",
      displayName: "PicnInReflections",
      component: (
        <ReflectionAfterTeachingDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnLE: {
      iconName: "PicnLE",
      displayName: "PicnLE",
      component: (
        <CognitiveDevelopmentDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnAssessments: {
      iconName: "PicnAssessments",
      displayName: "PicnAssessments",
      component: (
        <AssessmentsDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnTQues: {
      iconName: "PicnTQues",
      displayName: "PicnTQues",
      component: (
        <InquiryQuestionsDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnPurposeIntegration: {
      iconName: "PicnPurposeIntegration",
      displayName: "PicnPurposeIntegration",
      component: (
        <PurposeOfIntegrationDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    ReflectionAfterTeachingDuotoneBlue: {
      iconName: "ReflectionAfterTeachingDuotoneBlue",
      displayName: "ReflectionAfterTeachingDuotoneBlue",
      component: (
        <ReflectionAfterTeachingDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnLearningStandards: {
      iconName: "PicnLearningStandards",
      displayName: "PicnLearningStandards",
      component: (
        <LearningStandardsDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnInterdisCriteria: {
      iconName: "PicnInterdisCriteria",
      displayName: "PicnInterdisCriteria",
      component: (
        <IndisciplinaryCriteriaDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnLPA: {
      iconName: "PicnLPA",
      displayName: "PicnLPA",
      component: (
        <LearnerProfileDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    ObjectivesDuotoneViolet: {
      iconName: "ObjectivesDuotoneViolet",
      displayName: "ObjectivesDuotoneViolet",
      component: (
        <ObjectivesDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnDifferentiations: {
      iconName: "PicnDifferentiations",
      displayName: "PicnDifferentiations",
      component: (
        <DifferentiationDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    ReflectionPriorToTeachingDuotonePink: {
      iconName: "ReflectionPriorToTeachingDuotonePink",
      displayName: "ReflectionPriorToTeachingDuotonePink",
      component: (
        <ReflectionPriorToTeachingDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    LeAndTeachingStrategiesDuotonePink: {
      iconName: "LeAndTeachingStrategiesDuotonePink",
      displayName: "LeAndTeachingStrategiesDuotonePink",
      component: (
        <LeAndTeachingStrategiesDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnFormative: {
      iconName: "PicnFormative",
      displayName: "PicnFormative",
      component: (
        <FormativeAssessmentDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnGlobalContext: {
      iconName: "PicnGlobalContext",
      displayName: "PicnGlobalContext",
      component: (
        <GlobalContextDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnUnitDetails: {
      iconName: "PicnUnitDetails",
      displayName: "PicnUnitDetails",
      component: (
        <SpiralBookLinesDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnSummative: {
      iconName: "PicnSummative",
      displayName: "PicnSummative",
      component: (
        <SummativeAssessmentDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    LearnerProfileDuotoneGreen: {
      iconName: "LearnerProfileDuotoneGreen",
      displayName: "LearnerProfileDuotoneGreen",
      component: (
        <LearnerProfileDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnResources: {
      iconName: "PicnResources",
      displayName: "PicnResources",
      component: (
        <ResourceDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnSelfAssmnt: {
      iconName: "PicnSelfAssmnt",
      displayName: "PicnSelfAssmnt",
      component: (
        <SelfAssessmentDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    PicnContent: {
      iconName: "PicnContent",
      displayName: "PicnContent",
      component: (
        <ContentDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
  };

  return iconList;
};
